import { ContainerModule } from "inversify";

import { OnboardingProvider } from "../application/onboarding.provider";
import { FakeOnboardingProvider } from "./fake-onboarding.provider";
import { RestOnboardingProvider } from "./rest-onboarding.provider";

export const OnboardingModule = new ContainerModule(({ bind }) => {
  bind(OnboardingProvider).toDynamicValue(() => {
    return process.env.NEXT_PUBLIC_USE_FAKE_IMPLEMENTATIONS === "true"
      ? new FakeOnboardingProvider()
      : new RestOnboardingProvider();
  });
});
